import React from 'react';
import { ScreenLink } from '@gogame/screens';
import { influencersChannelsLink } from 'scenes/Influencers/InfluencersChannels/navigation';
import { FILTER_MASTER_CAMPAIGNS } from 'scenes/Influencers/InfluencersChannels/constants';
import { filtersSchema } from 'scenes/Influencers/InfluencersChannels/schemas';

export const InfluencerChannelsLink = ({ row, value }) => {
  if (!value.length) {
    return '-';
  }
  return (
    <ScreenLink
      link={influencersChannelsLink}
      params={{
        filters: {
          ...filtersSchema.default(),
          [FILTER_MASTER_CAMPAIGNS]: [row.id],
        },
        ready: true,
      }}
      target={'_blank'}
    >
      {value.length} channels
    </ScreenLink>
  );
};
